import React from "react"
import ReactAudioPlayer from "react-audio-player"
import Section from "@components/structure/Section/Section"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import * as styles from "./PostAudio.module.scss"

const PostAudio = (props) => (
  <Section margin className={styles.PostAudio}>
    <SiteWrapper textNarrow>
      <p>Prefer to listen to this article? Hit play below.</p>
      <ReactAudioPlayer
        className={styles.player}
        src={props.audio}
        controls
        controlsList="nodownload"
      />
    </SiteWrapper>
  </Section>
)

export default PostAudio
